import { HttpHandler } from 'msw'

import { getAllProducts } from './getAllProducts'
import { getProduct } from './getProduct'

export const products: HttpHandler[] = [getAllProducts, getProduct]
